import { Transform, Type } from "class-transformer";

export const TransformToDate = (target: any, propertyKey: string) => {
    Type(() => Date)(target, propertyKey);
    Transform((value) => (value ? new Date(value) : undefined))(target, propertyKey);
};
